<!-- Non Mobile -->
<div *ngIf="statusMap" 
  class="d-none d-md-flex slat-wrapper">

  <!-- Image -->
  <div *ngIf="!simpleSlat"
    [class.non-mobile-image]="!simpleSlat"
    [class.vertical-divider]="!simpleSlat"
    [class.simple-divider]="simpleSlat"
    [class.col-md-2]="simpleSlat">
    <div class="image-container">
      <ng-template *ngTemplateOutlet="img"></ng-template>
    </div>

    <!-- App ID -->
    <div *ngIf="!simpleSlat"
      class="mt-3 mb-3">
      <ng-template *ngTemplateOutlet="appId"></ng-template>
    </div>
  </div> 

  <!-- For My Applications Page -->
  <div *ngIf="!simpleSlat"
    class="d-flex flex-column flex-grow-1">
    <div class="d-flex justify-content-between m-3 divider">

      <!-- Program Details-->
      <div class="ms-4 mb-3">
        <ng-template *ngTemplateOutlet="programDetails"></ng-template>
      </div>

      <!-- Status Block -->
      <div class="text-right">
        <ng-template *ngTemplateOutlet="statusBlock"></ng-template>
      </div>
    </div>

    <div class="flex-grow-1">
      <!-- Forms -->
      <div *ngFor="let form of application.applicationForms; let first = first; let last = last"
        [class.last-form]="last">
        <div class="d-flex align-items-center">
          <div class="col-md-5 ms-3">
            <a *ngIf="application.status !== AppStatuses.Canceled" 
              href="javascript:void(0)"
              class="form-link"
              [ycTrackClick]="'Go to application'"
              (click)="goToApplication(form)">
              {{ formTranslationMap[form.formId]?.Name || form.name }}
            </a>
            <span *ngIf="application.status === AppStatuses.Canceled"
              class="form-name">
              {{ formTranslationMap[form.formId]?.Name || form.name }}
            </span>
          </div>
          <div>
            <!-- No Due Date-->
            <ng-container *ngIf="!form.dueDate || (application.status === AppStatuses.Hold)">
              <yc-fa
                [icon]="formStatusMap[form.status].icon"
                [light]="true"
                [ngClass]="formStatusMap[form.status].iconClass"
                class="me-2">
              </yc-fa>
              <yc-i18n *ngIf="(form.status !== FormStatuses.NotSent) &&
                (form.status !== FormStatuses.Sent)"
                key="APPLY:textStatusOnDateDynamic"
                [context]="{
                  status: formStatusMap[form.status].translated,
                  date: form | gcFormStatusDate
                }"
                defaultValue="__status__ on __date__">
              </yc-i18n>
              <ng-container *ngIf="(form.status === FormStatuses.NotSent) ||
                (form.status === FormStatuses.Sent)">
                {{ formStatusMap[form.status].translated }}
              </ng-container>
            </ng-container>
            <!-- Has Due Date -->
            <ng-container *ngIf="form.dueDate">
              <yc-fa *ngIf="application.status !== AppStatuses.Hold"
                icon="exclamation-circle"
                [light]="true"
                class="text-warning me-2">
              </yc-fa>
              <ng-container *ngIf="application.status === AppStatuses.Hold"> (</ng-container>
              <yc-i18n
                key="APPLY:textFormDueOn"
                [context]="{
                  date: form.dueDate | ycFormDueDate
                }"
                defaultValue="Form due on __date__">
              </yc-i18n>
              <ng-container *ngIf="application.status === AppStatuses.Hold">)</ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="application.files?.length > 0"
        class="file-divider">
        <hr>
      </div>
      <!-- Files -->
      <div *ngFor="let file of application.files; let first = first; let last = last"
        [class.last-form]="last">
        <div class="d-flex align-items-center">
          <div class="col-md-5 ms-3">
            <a class="form-link"
              href="javascript:void(0)"
              [ycTrackClick]="'Open application file'"
              (click)="openFile(file)">
              {{ file.fileName }}
            </a>
          </div>
          <div>
            <yc-fa
              icon="file-alt"
              [light]="true"
              class="me-2 text-link">
            </yc-fa>
            <yc-i18n
              key="GLOBAL:textFileAddedDate"
              [context]="{
                date: file.uploadedDate | ycStartOfDayDateFormatter
              }"
              defaultValue="File added __date__">
            </yc-i18n>
          </div>
        </div>
      </div>
    </div>

    <div class="gray-box flex-grow-1">

      <!-- Create Date -->
      <div class="create-date-non-mobile">
        <ng-template *ngTemplateOutlet="createDate"></ng-template>
      </div>

      <!-- Manage Application -->
      <ng-template *ngTemplateOutlet="manageApplication; context: {
        isMobile: false
      }"></ng-template>
    </div>
  </div>


  <!-- For Programs Page -->
  <ng-container *ngIf="simpleSlat">
    <div class="d-flex justify-content-between flex-grow-1 p-3 align-items-center">
      <div class="simple-left">
        <div class="applicant-string">
          {{ application.applicantDescription }}
        </div>
        <div *ngIf="application.nominationDescription" class="mt-2">
          {{ application.nominationDescription }}
        </div>

        <ng-template *ngTemplateOutlet="appId"></ng-template>
        <div *ngIf="!applicationIsDraft">
          <yc-i18n
            key="GLOBAL:textSubmittedOnDynamic"
            [context]="{
              date: application.submissionDate | ycFormatDate
            }"
            defaultValue="Submitted on __date__">
          </yc-i18n>
        </div>
        <div *ngIf="!applicationIsDraft">
          <yc-i18n
            key="common:hdrStatus"
            defaultValue="Status">
          </yc-i18n>: 
          <ng-template 
            *ngTemplateOutlet="statusBlock; context: {
              'hideIcon': true
            }">
          </ng-template>
        </div>
      </div>
      <ng-template *ngTemplateOutlet="editButton; context: {
        isMobile: false
      }"></ng-template>
    </div>
  </ng-container>
</div>
<!-- Communications Drilldown -->
<div *ngIf="commsOpen"
  class="slat-wrapper comms-wrapper">
  <div class="font-550 m-2 font-875-rem">
    <yc-i18n
      key="GLOBAL:textCommunications"
      defaultValue="Communications">
    </yc-i18n>
  </div>
  <yc-table
    [key]="commTableKey"
    [simple]="true"
    [topLevelFilters]="topLevelFilters"
    [rows]="applicationEmails$ | async">
    <!-- Subject -->
    <ng-container *ycTableColumn="'common:labelSubject';
      prop: 'subject',
      let row;">
      <yc-button
        [link]="true"
        [translatedText]="row.subject"
        (onClick)="openFlyout(row)">
      </yc-button>
    </ng-container>

    <!-- Date Sent -->
    <ng-container *ycTableColumn="'common:textDateSent';
      prop: 'sentDate',
      let row;">
      {{ row.sentDate | ycFormatDate:  DATE_TIME_FORMAT }}
    </ng-container>
  </yc-table>
</div>


<!-- Mobile -->
<div *ngIf="statusMap" class="d-flex d-md-none slat-wrapper"
  [class.flex-column]="!simpleSlat"
  [class.flex-row]="simpleSlat">
  <ng-container >
    <div class="d-flex mobile-image align-items-center"
      [class.justify-content-between]="!simpleSlat"
      [class.justify-content-start]="simpleSlat"
      [class.divider]="!simpleSlat">
      <!-- Image -->
      <div>
        <ng-template *ngTemplateOutlet="img"></ng-template>
      </div>

      <!-- Status / App ID -->
      <div *ngIf="!simpleSlat" class="mobile-status-app-block">
        <ng-template *ngTemplateOutlet="statusBlock"></ng-template>
        <ng-template *ngTemplateOutlet="appId; context: {
          isMobile: true
        }"></ng-template>
      </div>
      
    </div> 

    <!-- Program Details -->
    <div *ngIf="!simpleSlat" class="mobile-program-block">
      <ng-template *ngTemplateOutlet="programDetails"></ng-template>
      <hr>
    </div>

    <div *ngIf="simpleSlat" class="simple-mobile-program-block">
      <ng-template *ngTemplateOutlet="mobileSimpleProgramDetails"></ng-template>
      <ng-template *ngTemplateOutlet="appId; context: {
        isMobile: true
      }"></ng-template>
    </div>

    <div *ngIf="!simpleSlat" class="flex-grow-1">
      <!-- Forms -->
      <div *ngFor="let form of application.applicationForms; let first = first; let last = last"
        [class.last-form]="last">
        <div class="d-flex align-items-center flex-column">
          <div class="col-md-5 p-0">
            <a href="javascript:void(0)"
              class="form-link"
              [ycTrackClick]="'Go to application'"
              (click)="goToApplication(form)">
                {{ formTranslationMap[form.formId]?.Name ||   
                  form.name }}
              </a>
          </div>
          <div class="col-md-5">
            <yc-fa
              [icon]="formStatusMap[form.status].icon"
              [light]="true"
              [ngClass]="formStatusMap[form.status].iconClass"
              class="me-2">
            </yc-fa>
            <yc-i18n
              key="APPLY:textStatusOnDateDynamic"
              [context]="{
                status: formStatusMap[form.status].translated,
                date: form | gcFormStatusDate
              }"
              defaultValue="__status__ on __date__">
            </yc-i18n>
          </div>
        </div>
      </div>

      <div *ngIf="application.files?.length > 0"
        class="file-divider">
        <hr>
      </div>
      
      <!-- Files -->
      <div *ngFor="let file of application.files; let first = first; let last = last"
        [class.last-form]="last">
        <div class="d-flex align-items-center flex-column">
          <div class="col-md-5 p-0">
            <a class="form-link"
              href="javascript:void(0)"
              [ycTrackClick]="'Open application file'"
              (click)="openFile(file)">
              {{ file.fileName }}
            </a>
          </div>
          <div class="col-md-5">
            <yc-fa
              icon="file-alt"
              [light]="true"
              class="me-2 text-link">
            </yc-fa>
            <yc-i18n
              key="GLOBAL:textFileAddedDate"
              [context]="{
                date: file.uploadedDate | ycStartOfDayDateFormatter
              }"
              defaultValue="File added __date__">
            </yc-i18n>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="simpleSlat" class="mobile-edit-button">
      <ng-template *ngTemplateOutlet="editButton; context: {
        isMobile: true
      }"></ng-template>
    </div>

    <div *ngIf="!simpleSlat" class="gray-box">
      <!-- Create Date -->
        <ng-template *ngTemplateOutlet="createDate"></ng-template>
        <!-- Manage Application -->
        <ng-template *ngTemplateOutlet="manageApplication; context: {
          isMobile: true
        }"></ng-template>
    </div>

  </ng-container>

</div>


<!-- Start Templates -->

<!-- App ID Template -->
<ng-template #appId
  let-isMobile="isMobile">
  <div [id]="(isMobile ? 'mobile-' : 'standard-') + application.applicationId">
    <yc-i18n
      [key]="isNomination ? 'GLOBAL:textNominationID' : 'common:textApplicationId'"
      [defaultValue]="isNomination ? 'Nomination ID' : 'Application ID'">            
    </yc-i18n>: {{ application.applicationId }}
  </div>
</ng-template>

<!-- Image Template -->
<ng-template #img>
  <img class="slat-program-logo"
    [src]="(application.grantProgramLogoUrl || application.clientLogoUrl) | gcAddStaticResourceSAS" 
    [alt]="application.clientName + ' ' + ('BRAND:hdrLogo' | ycI18n: 'Logo')">
</ng-template>

<!-- Program Details Template -->
<ng-template #programDetails>
  <h2 [class]="!!application.grantProgramGuidelines ? 'break-word program-name remove-line-height' : 'break-word program-name'">
    {{ programTranslationMap[application.grantProgramId]?.Name ||   
      application.grantProgramName }}
  </h2>
  <div *ngIf="!!application.grantProgramGuidelines" class="mb-2">
    <yc-button
      [borderOnHover]="false"
      [link]="true"
      [langKey]="'PROGRAM:viewGuidelines'"
      [defaultText]="'View Guidelines'"
      (onClick)="viewGuidelines()">
    </yc-button>
  </div>
  <div>
    {{ application.applicantDescription }}
  </div>
  <div *ngIf="application.nominationDescription" class="mt-2">
    {{ application.nominationDescription }}
  </div>
</ng-template>

<!-- Mobile Simple Program Details Template -->
<ng-template #mobileSimpleProgramDetails>
  <h2 class="break-word program-name">
    {{ programTranslationMap[application.grantProgramId]?.Name ||   
      application.grantProgramName }}
  </h2>
</ng-template>

<!-- Status Block Template -->
<ng-template #statusBlock
  let-hideIcon="hideIcon">
  <ng-container>
    <yc-fa *ngIf="!hideIcon"
      icon="circle" 
      class="me-2"
      [ngClass]="statusMap[application.status]?.iconClass">
    </yc-fa>
    <ng-container *ngIf="!(application.status === AppStatuses.Approved &&
      !!application.nominee)">
      {{ statusMap[application.status]?.translated }}
    </ng-container>
    <ng-container *ngIf="application.status === AppStatuses.Approved &&
      !!application.nominee">
      <yc-i18n
        key="GLOBAL:textNominationAccepted"
        defaultValue="Nomination accepted">
      </yc-i18n>
    </ng-container>
    <ng-container *ngIf="!!application.previousApplicationStatusId &&
      application.status === AppStatuses.Hold">
      ({{ statusMap[application.previousApplicationStatusId]?.translated }})
    </ng-container>
  </ng-container>
</ng-template>

<!-- Create Date Template -->
<ng-template #createDate>
  <div class="create-date">
    <yc-i18n
      key="GLOBAL:textCreatedOnDynamic"
      [context]="{
        'date': application.createdDate | ycFormatDate
      }"
      defaultValue="Created on __date__">
    </yc-i18n>
  </div>  
</ng-template>

<!-- Manage App Template -->
<ng-template #manageApplication
  let-isMobile="isMobile">
  <div class="applicants">
    <yc-button *ngIf="application.canManage"
      [link]="true"
      [ariaDescribedBy]="(isMobile ? 'mobile-' : 'standard-') + application.applicationId"
      [isDropdownButton]="true"
      [dropdownActions]="dropdownActions"
      [langKey]="'APPLY:textManage'"
      [defaultText]="'Manage'">
    </yc-button>

    <yc-button *ngIf="!isMobile && !simpleSlat && application.partnerId !== 1"
      class="ms-3"
      [link]="true"
      [ariaDescribedBy]="'standard-' + application.applicationId"
      [langKey]="commsOpen ? 'GLOBAL:textHideCommunications' : 'GLOBAL:textViewCommunications'"
      [defaultText]="commsOpen ? 'Hide communications' : 'View communications'"
      (onClick)="toggleComms()">
    </yc-button>
  </div>
</ng-template>

<!-- Edit Button Template -->
<ng-template #editButton
  let-isMobile="isMobile">
  <yc-button
    [primary]="isMobile ? false : true"
    [icon]="isMobile ? true : false"
    [fontAwesomeIcon]="isMobile ? 'chevron-right' : ''"
    [tooltipText]="isMobile ?
      ((isCopy ? 'common:textCopy' : (canEdit ? 'common:textEdit' : 'common:textView')) | ycI18n: (isCopy ? 'Copy' : (canEdit ? 'Edit' : 'View'))) :
      ''"
    [ariaDescribedBy]="(isMobile ? 'mobile-' : 'standard-') + application.applicationId"
    [langKey]="isMobile ?
      '' :
      (isCopy ? 'common:textCopy' : (canEdit ? 'common:textEdit' : 'common:textView'))"
    [defaultText]="isMobile ?
      '' :
      (isCopy ? 'Copy' : (canEdit ? 'Edit' : 'View'))"
    (onClick)="selectApplication()">  
  </yc-button>
</ng-template>

<!-- End Templates -->
  